import React from 'react';
import styled from 'styled-components';
import { Row, Col, Button, Tooltip } from 'antd';
import { path } from 'ramda';

import Logo from 'components/atoms/logo';
import { useIntl } from 'common/config/i18n';

import packageJson from '../../../../package.json';
import { loginRedirection } from 'hooks/use-login-redirection';

interface Props {
  showUpcomingPasswordExpiryMessage: boolean;
  fullUserName?: string;
  logOutAction?: (e: React.SyntheticEvent) => void;
  login?: boolean;
  version?: string;
  readAccesses: {
    canReadCirculations: boolean;
    canReadCustomerFlux: boolean;
    canReadHistorisation: boolean;
  };
}

const Title1 = styled.h1`
  display: inline;
  font-size: 2rem;
  color: #e60075;
  font-weight: 600;
  padding: 0;
  margin: 0;
`;
const Title2 = styled.h1`
  display: inline;
  font-size: 2rem;
  color: #00acd0 !important;
  font-weight: 600;
  padding: 0;
  margin: 0;
`;
const HeaderWrapper = styled.header`
  background-color: white;
  display: flex;
  padding: 32px;
  width: 100%;
`;

const LogoWrapper = styled.div`
  width: 88px;
  height: 88px;
  cursor: pointer;
`;
const TitleWrapper = styled.div`
  padding-left: 16px;
  h1 {
    color: ${(props) => (props.theme ? path(['colors', 'secondary', 'main'], props.theme) : 'inherit')};
    margin: 0;
  }
  p {
    margin: 0;
  }
  cursor: pointer;
`;
const ProfileInfos = styled.div`
  text-align: center;
  button.disconnect {
    background-color: ${(props) => (props.theme ? path(['colors', 'primary', 'main'], props.theme) : 'inherit')};
    border-color: ${(props) => (props.theme ? path(['colors', 'primary', 'main'], props.theme) : 'inherit')};

    &:hover,
    &:active,
    &:focus {
      background-color: ${(props) => (props.theme ? path(['colors', 'primary', 'dark'], props.theme) : 'inherit')};
      border-color: ${(props) => (props.theme ? path(['colors', 'primary', 'dark'], props.theme) : 'inherit')};
    }
  }

  p {
    margin-bottom: 5px;
    padding: 0;
    font-size: 1rem;
  }
`;
const UpcomingPasswordExpiryMessage = styled.div`
  display: flex;
  justify-content: end;
`;

const Header: React.FC<Props> = ({
  showUpcomingPasswordExpiryMessage,
  fullUserName,
  logOutAction,
  login,
  version,
  readAccesses,
}) => {
  const { t } = useIntl();

  const { canReadCirculations, canReadCustomerFlux, canReadHistorisation } = readAccesses;

  const clickLogoHandler = () => {
    loginRedirection({
      canReadCirculations,
      canReadCustomerFlux,
      canReadHistorisation,
    });
  };

  return (
    <HeaderWrapper>
      <Row style={{ width: '100%' }}>
        <Col span={login ? 24 : 12}>
          <Row justify={login ? 'center' : undefined} align="middle" style={{ width: '100%' }}>
            <LogoWrapper onClick={clickLogoHandler}>
              <Logo />
            </LogoWrapper>
            <TitleWrapper onClick={clickLogoHandler}>
              <Title1>{t('header', 'TITLE1')}</Title1>
              <Title2>{t('header', 'TITLE2')}</Title2>
              <p>
                {`${t('env', 'front')} ${packageJson.version}`} <br />
                {`${t('env', 'middleware')} ${version}`}
              </p>
            </TitleWrapper>
          </Row>
        </Col>
        {!!fullUserName && (
          <Col span="12">
            <Row justify="end" align="middle" style={{ height: '95%' }}>
              <ProfileInfos>
                <p>{fullUserName}</p>

                <Button type="primary" shape="round" size="large" onClick={logOutAction} className="disconnect">
                  {t('Buttons', 'DISCONNECT_BUTTON')}
                </Button>
              </ProfileInfos>
            </Row>
            {showUpcomingPasswordExpiryMessage && (
              <Tooltip title={t('header', 'passwordExpiryTooltip')} placement="bottomRight">
                <UpcomingPasswordExpiryMessage>{t('header', 'passwordExpiryMessage')}</UpcomingPasswordExpiryMessage>
              </Tooltip>
            )}
          </Col>
        )}
      </Row>
    </HeaderWrapper>
  );
};

export default Header;
